import { ProductCoreBase } from "./product.core.base"


export class ProductCore extends ProductCoreBase {

}